import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as bookingService from "../../services/booking.services";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { useTranslation } from "react-i18next";
import moment from "moment";

const ConsultationHistoryView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [booking, setBooking] = useState(null);
  const [list, setList] = useState([]);
  const [loader, setLoader] = useState(true);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Consultations", url: "/admin/consultation/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    setLoader(true);
    bookingService
      .History(params.id)
      .then((response) => {
        setBooking(response?.data?.booking || null);
        setList(response?.data?.list || []);
        setLoader(false);
      })
      .catch((error) => {
        console.log("error=====>", error);
        setLoader(false);
      });
  }, [params.id]);

  const getDisplayName = (row) => {
    if (row?.role === "astrologer") {
      return row?.astrologer?.name || row?.astrologer?.screen_name || "N/A";
    }
    return row?.user?.name || "N/A";
  };

  const capitalizeFirst = (value) => {
    if (!value) return "N/A";
    return value.charAt(0).toUpperCase() + value.slice(1);
  };

  const formatJoinAt = (date) => {
    if (!date) return "N/A";
    return moment(date).format("DD MMM YYYY, HH:mm:ss");
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="main-content-label mb-0">Consultation Session History</h6>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={() => navigate("/admin/consultation/list/1")}
                >
                  <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                  {t("btn_back")}
                </button>
              </div>

              {booking ? (
                <div className="mb-3">
                  <span className="me-3">
                    <b>Order Number:</b> <strong className="text-primary">{booking?.order_number || `ORD-CONS-${booking?.id}`}</strong>
                  </span>
                  <span className="me-3">
                    <b>User:</b> {booking?.user?.name || "N/A"}
                  </span>
                  <span className="me-3">
                    <b>Astrologer:</b> {booking?.astrologer?.name || "N/A"}
                  </span>
                  <span>
                    <b>Type:</b> {booking?.consultation_type || "N/A"}
                  </span>
                </div>
              ) : null}

              <div className="table-responsive">
                <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Role</th>
                      <th>Session Mode</th>
                      <th>IP Address</th>
                      <th>Join At</th>
                      <th>Connected Seconds</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loader ? (
                      <tr>
                        <td colSpan={7} className="text-center">
                          <Loader />
                        </td>
                      </tr>
                    ) : list.length ? (
                      list.map((row, i) => (
                        <tr key={row.id || i}>
                          <td>{i + 1}</td>
                          <td className="text-capitalize">{getDisplayName(row)}</td>
                          <td>{capitalizeFirst(row.role)}</td>
                          <td>{capitalizeFirst(row.session_mode)}</td>
                          <td>{row.ip_address || "N/A"}</td>
                          <td>{formatJoinAt(row.join_at)}</td>
                          <td>{row.connected_seconds ?? 0}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} className="text-center">
                          {t("msg_no_records")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConsultationHistoryView;
